module.exports = __webpack_public_path__ + "img/Tecnotion_logo_2021_White.d313e6d0.png";